"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PixelMeasurementApi = void 0;
var runtime = require("../runtime");
var index_1 = require("../models/index");
/**
 *
 */
var PixelMeasurementApi = /** @class */ (function (_super) {
    __extends(PixelMeasurementApi, _super);
    function PixelMeasurementApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a new event for a pixel.
     * Create event
     */
    PixelMeasurementApi.prototype.createEventRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling createEvent.');
                        }
                        if (requestParameters.pixelId === null || requestParameters.pixelId === undefined) {
                            throw new runtime.RequiredError('pixelId', 'Required parameter requestParameters.pixelId was null or undefined when calling createEvent.');
                        }
                        if (requestParameters.createEventRequest === null || requestParameters.createEventRequest === undefined) {
                            throw new runtime.RequiredError('createEventRequest', 'Required parameter requestParameters.createEventRequest was null or undefined when calling createEvent.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_accounts/{ad_account_id}/pixels/{pixel_id}/events".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("pixel_id", "}"), encodeURIComponent(String(requestParameters.pixelId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.CreateEventRequestToJSON)(requestParameters.createEventRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.EventFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create a new event for a pixel.
     * Create event
     */
    PixelMeasurementApi.prototype.createEvent = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createEventRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new pixel. A PAGE_VIEW event will be created by default and associated with the new pixel.
     * Create pixel
     */
    PixelMeasurementApi.prototype.createPixelRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling createPixel.');
                        }
                        if (requestParameters.createPixelRequest === null || requestParameters.createPixelRequest === undefined) {
                            throw new runtime.RequiredError('createPixelRequest', 'Required parameter requestParameters.createPixelRequest was null or undefined when calling createPixel.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_accounts/{ad_account_id}/pixels".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.CreatePixelRequestToJSON)(requestParameters.createPixelRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.PixelFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create a new pixel. A PAGE_VIEW event will be created by default and associated with the new pixel.
     * Create pixel
     */
    PixelMeasurementApi.prototype.createPixel = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createPixelRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new pixel.
     * Create pixel
     */
    PixelMeasurementApi.prototype.createPixelInBusinessRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.businessId === null || requestParameters.businessId === undefined) {
                            throw new runtime.RequiredError('businessId', 'Required parameter requestParameters.businessId was null or undefined when calling createPixelInBusiness.');
                        }
                        if (requestParameters.createPixelRequest1 === null || requestParameters.createPixelRequest1 === undefined) {
                            throw new runtime.RequiredError('createPixelRequest1', 'Required parameter requestParameters.createPixelRequest1 was null or undefined when calling createPixelInBusiness.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/businesses/{business_id}/pixels".replace("{".concat("business_id", "}"), encodeURIComponent(String(requestParameters.businessId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.CreatePixelRequest1ToJSON)(requestParameters.createPixelRequest1),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.Pixel1FromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create a new pixel.
     * Create pixel
     */
    PixelMeasurementApi.prototype.createPixelInBusiness = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createPixelInBusinessRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get pixel by id for a given business.
     * Get pixel by id for a given business.
     */
    PixelMeasurementApi.prototype.getPixelByIdRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.businessId === null || requestParameters.businessId === undefined) {
                            throw new runtime.RequiredError('businessId', 'Required parameter requestParameters.businessId was null or undefined when calling getPixelById.');
                        }
                        if (requestParameters.pixelId === null || requestParameters.pixelId === undefined) {
                            throw new runtime.RequiredError('pixelId', 'Required parameter requestParameters.pixelId was null or undefined when calling getPixelById.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/businesses/{business_id}/pixels/{pixel_id}".replace("{".concat("business_id", "}"), encodeURIComponent(String(requestParameters.businessId))).replace("{".concat("pixel_id", "}"), encodeURIComponent(String(requestParameters.pixelId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.Pixel1FromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get pixel by id for a given business.
     * Get pixel by id for a given business.
     */
    PixelMeasurementApi.prototype.getPixelById = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPixelByIdRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get pixel based on the pixel id. Set include_events to include the events that have been set up, such as page view, purchase, and lead events. Set include_historical_events to include hourly aggregates of counts of events. See parameter descriptions for more information. Note: Including historical events can add several seconds to the response time.
     * Get pixel for a pixel id
     */
    PixelMeasurementApi.prototype.getPixelByPixelIdRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling getPixelByPixelId.');
                        }
                        if (requestParameters.pixelId === null || requestParameters.pixelId === undefined) {
                            throw new runtime.RequiredError('pixelId', 'Required parameter requestParameters.pixelId was null or undefined when calling getPixelByPixelId.');
                        }
                        queryParameters = {};
                        if (requestParameters.includeEvents !== undefined) {
                            queryParameters['include_events'] = requestParameters.includeEvents;
                        }
                        if (requestParameters.includeHistoricalEvents !== undefined) {
                            queryParameters['include_historical_events'] = requestParameters.includeHistoricalEvents;
                        }
                        if (requestParameters.historicalEventsStartDate !== undefined) {
                            queryParameters['historical_events_start_date'] = requestParameters.historicalEventsStartDate;
                        }
                        if (requestParameters.historicalEventsEndDate !== undefined) {
                            queryParameters['historical_events_end_date'] = requestParameters.historicalEventsEndDate;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_accounts/{ad_account_id}/pixels/{pixel_id}".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("pixel_id", "}"), encodeURIComponent(String(requestParameters.pixelId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.PixelFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get pixel based on the pixel id. Set include_events to include the events that have been set up, such as page view, purchase, and lead events. Set include_historical_events to include hourly aggregates of counts of events. See parameter descriptions for more information. Note: Including historical events can add several seconds to the response time.
     * Get pixel for a pixel id
     */
    PixelMeasurementApi.prototype.getPixelByPixelId = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPixelByPixelIdRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get all pixels for the ad account. Set include_events to include the events that have been set up, such as page view, purchase, and lead events. Set include_historical_events to include hourly aggregates of counts of events. See parameter descriptions for more information. Note: Including historical events can add several seconds to the response time.
     * Get all pixels for an ad account
     */
    PixelMeasurementApi.prototype.getPixelsByAdAccountIdRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling getPixelsByAdAccountId.');
                        }
                        queryParameters = {};
                        if (requestParameters.includeEvents !== undefined) {
                            queryParameters['include_events'] = requestParameters.includeEvents;
                        }
                        if (requestParameters.includeHistoricalEvents !== undefined) {
                            queryParameters['include_historical_events'] = requestParameters.includeHistoricalEvents;
                        }
                        if (requestParameters.historicalEventsStartDate !== undefined) {
                            queryParameters['historical_events_start_date'] = requestParameters.historicalEventsStartDate;
                        }
                        if (requestParameters.historicalEventsEndDate !== undefined) {
                            queryParameters['historical_events_end_date'] = requestParameters.historicalEventsEndDate;
                        }
                        if (requestParameters.limit !== undefined) {
                            queryParameters['limit'] = requestParameters.limit;
                        }
                        if (requestParameters.offset !== undefined) {
                            queryParameters['offset'] = requestParameters.offset;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_accounts/{ad_account_id}/pixels".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.PixelsResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get all pixels for the ad account. Set include_events to include the events that have been set up, such as page view, purchase, and lead events. Set include_historical_events to include hourly aggregates of counts of events. See parameter descriptions for more information. Note: Including historical events can add several seconds to the response time.
     * Get all pixels for an ad account
     */
    PixelMeasurementApi.prototype.getPixelsByAdAccountId = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPixelsByAdAccountIdRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get all pixels for the business account.
     * Get all pixels for a business account
     */
    PixelMeasurementApi.prototype.getPixelsByBusinessIdRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.businessId === null || requestParameters.businessId === undefined) {
                            throw new runtime.RequiredError('businessId', 'Required parameter requestParameters.businessId was null or undefined when calling getPixelsByBusinessId.');
                        }
                        queryParameters = {};
                        if (requestParameters.includeEvents !== undefined) {
                            queryParameters['include_events'] = requestParameters.includeEvents;
                        }
                        if (requestParameters.includeHistoricalEvents !== undefined) {
                            queryParameters['include_historical_events'] = requestParameters.includeHistoricalEvents;
                        }
                        if (requestParameters.historicalEventsStartDate !== undefined) {
                            queryParameters['historical_events_start_date'] = requestParameters.historicalEventsStartDate;
                        }
                        if (requestParameters.historicalEventsEndDate !== undefined) {
                            queryParameters['historical_events_end_date'] = requestParameters.historicalEventsEndDate;
                        }
                        if (requestParameters.limit !== undefined) {
                            queryParameters['limit'] = requestParameters.limit;
                        }
                        if (requestParameters.offset !== undefined) {
                            queryParameters['offset'] = requestParameters.offset;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/businesses/{business_id}/pixels".replace("{".concat("business_id", "}"), encodeURIComponent(String(requestParameters.businessId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.PixelsResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get all pixels for the business account.
     * Get all pixels for a business account
     */
    PixelMeasurementApi.prototype.getPixelsByBusinessId = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPixelsByBusinessIdRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Map a pixel from SpAA to Ads Manager.
     * Map pixel
     */
    PixelMeasurementApi.prototype.mapPixelRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling mapPixel.');
                        }
                        if (requestParameters.pixelId === null || requestParameters.pixelId === undefined) {
                            throw new runtime.RequiredError('pixelId', 'Required parameter requestParameters.pixelId was null or undefined when calling mapPixel.');
                        }
                        if (requestParameters.mapPixelRequest === null || requestParameters.mapPixelRequest === undefined) {
                            throw new runtime.RequiredError('mapPixelRequest', 'Required parameter requestParameters.mapPixelRequest was null or undefined when calling mapPixel.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/internal/ad_accounts/{ad_account_id}/mapping/pixels/{pixel_id}".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("pixel_id", "}"), encodeURIComponent(String(requestParameters.pixelId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.MapPixelRequestToJSON)(requestParameters.mapPixelRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.MapPixelResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Map a pixel from SpAA to Ads Manager.
     * Map pixel
     */
    PixelMeasurementApi.prototype.mapPixel = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.mapPixelRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update an existing pixel.
     * Update pixel
     */
    PixelMeasurementApi.prototype.updatePixelByIdRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.businessId === null || requestParameters.businessId === undefined) {
                            throw new runtime.RequiredError('businessId', 'Required parameter requestParameters.businessId was null or undefined when calling updatePixelById.');
                        }
                        if (requestParameters.pixelId === null || requestParameters.pixelId === undefined) {
                            throw new runtime.RequiredError('pixelId', 'Required parameter requestParameters.pixelId was null or undefined when calling updatePixelById.');
                        }
                        if (requestParameters.updatePixelRequest === null || requestParameters.updatePixelRequest === undefined) {
                            throw new runtime.RequiredError('updatePixelRequest', 'Required parameter requestParameters.updatePixelRequest was null or undefined when calling updatePixelById.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/businesses/{business_id}/pixels/{pixel_id}".replace("{".concat("business_id", "}"), encodeURIComponent(String(requestParameters.businessId))).replace("{".concat("pixel_id", "}"), encodeURIComponent(String(requestParameters.pixelId))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.UpdatePixelRequestToJSON)(requestParameters.updatePixelRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.UpdatePixelResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update an existing pixel.
     * Update pixel
     */
    PixelMeasurementApi.prototype.updatePixelById = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updatePixelByIdRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return PixelMeasurementApi;
}(runtime.BaseAPI));
exports.PixelMeasurementApi = PixelMeasurementApi;
